import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import RentalTermSheet from "../components/quote-pdfs/rental-term-sheet-pdf";
import RentalPremierTermSheet from "../components/quote-pdfs/RentalPremierTermSheet";
import FixAndFlipTermSheet from "../components/quote-pdfs/stf-term-sheet-pdf";

export const getFileName = (filename, action) => {
  const date = new Date();
  const filenameArr = filename.split(" ");

  filenameArr.push(date.toLocaleDateString().replaceAll("/", "-"));

  if (action === "INTERNAL") {
    filenameArr.unshift("Internal");
  }

  return filenameArr.join("_");
};

export const generateRentalPdf = async (
  documentData,
  filename,
  quoteType,
  discussionArray
) => {
  if ((quoteType = "Rental")) {
    generateRentalTermPdf(documentData, filename, discussionArray);
  } else {
    generateRentalPremierTermPdf(documentData, filename);
  }
};

const generateRentalTermPdf = async (
  documentData,
  filename,
  discussionArray
) => {
  const { quote, calculation, scenarios, action, userProfile, metadata } =
    documentData;

  const blob = await pdf(
    <RentalTermSheet
      quote={quote}
      calculation={calculation}
      scenarios={scenarios}
      action={action}
      userProfile={userProfile}
      metadata={metadata}
      discussionArray={discussionArray}
    />
  ).toBlob();
  saveAs(blob, `${getFileName(filename, action)}.pdf`);
};

const generateRentalPremierTermPdf = async (documentData, filename) => {
  const { quote, calculation, scenarios, action, userProfile } = documentData;

  const blob = await pdf(
    <RentalPremierTermSheet
      quote={quote}
      calculation={calculation}
      scenarios={scenarios}
      action={action}
      userProfile={userProfile}
    />
  ).toBlob();
  saveAs(blob, `${getFileName(filename, action)}.pdf`);
};

export const generateShortTermFinancePdf = async (
  documentData,
  filename,
  discussionArray
) => {
  const { calculation, quote, action, userProfile, metadata } = documentData;

  const blob = await pdf(
    <FixAndFlipTermSheet
      calculation={calculation}
      quote={quote}
      action={action}
      userProfile={userProfile}
      metadata={metadata}
      discussionArray={discussionArray}
    />
  ).toBlob();
  saveAs(blob, `${getFileName(filename, action)}.pdf`);
};
